/**
 * Recently viewed (PDP) -> localStorage
 * This runs globally (theme.liquid) but only writes on product pages.
 */
(function () {
  'use strict';

  function safeJsonParse(v) {
    try { return JSON.parse(v); } catch (e) { return null; }
  }

  function normalizeHtml(html) {
    return (typeof html === 'string') ? html : '';
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    if (!window || !window.location) return;
    if (!document || !document.body) return;

    // Only run on PDP
    var bodyClass = document.body.className || '';
    var isProductTemplate = bodyClass.indexOf('template-product') !== -1;
    if (!isProductTemplate && !/\/products\//.test(window.location.pathname)) {
      return;
    }

    // Prefer Liquid-injected product context when available
    var productObj = window.__bbPdpProduct || null;

    var productUrl = (productObj && productObj.url) ? productObj.url : window.location.pathname;
    var featuredImage = (productObj && productObj.featured_image) ? productObj.featured_image : '';
    var title = (productObj && productObj.title) ? productObj.title : (document.title || '');

    // Match structure used in `sections/recently.liquid`
    var pdpData = {
      productTitle: normalizeHtml(title),
      productImg: featuredImage,
      productUrl: productUrl,
      productmeta: ''
    };

    var numberOfProduct = 9;
    var key = 'recently_viewed';
    var productArr = safeJsonParse(window.localStorage && window.localStorage.getItem(key)) || [];
    if (!Array.isArray(productArr)) productArr = [];

    // Dedupe by URL (more stable than HTML title)
    var isAlready = productArr.some(function (item) {
      return item && item.productUrl === pdpData.productUrl;
    });

    if (!isAlready) {
      if (productArr.length >= numberOfProduct) productArr.pop();
      productArr.unshift(pdpData);
      try {
        window.localStorage.setItem(key, JSON.stringify(productArr));
      } catch (e) {
        // ignore quota / privacy mode
      }
    }
  });
})();

